import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enterprise-software-development',
  templateUrl: './enterprise-software-development.component.html',
  styleUrls: ['./enterprise-software-development.component.scss']
})
export class EnterpriseSoftwareDevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
